import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getEnvVariables} from "../../helpers/getEnvVariables";
const {REACT_APP_URL} = getEnvVariables();
export const billingApi = createApi({
  reducerPath: "billing",
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_URL,
    prepareHeaders: (headers, {getState, endpoint}) => {
      const token = JSON.parse(localStorage.getItem("user")!)?.token;
      headers.set("Authorization", token);
      headers.set("Content-Type", "application/json");
      return headers;
    },
    responseHandler: async (response) => {
      const data = await response.json();
      return {
        ...data,
        meta: {
          status: response.status,
        },
      };
    },
  }),
  endpoints: (builder) => ({
    saveBilling: builder.mutation({
      query: (data) => ({
        url: "/api/v2/invoice/user",
        method: "POST",
        body: data,
      }),
    }),
    getBillings: builder.query({
      query: () => ({
        url: "/api/v2/invoice/user",
        params: {isDeleted: false},
      }),
    }),
    deleteBilling: builder.mutation({
      query: (id) => ({
        url: `/api/v2/invoice/user`,
        method: "DELETE",
        body: {id},
      }),
    }),
  }),
});

export const {
  useSaveBillingMutation,
  useGetBillingsQuery,
  useDeleteBillingMutation,
} = billingApi;
